import React, { useEffect, useState, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Table from "../../components/Table/Table";
import { getHospitalDetails,changeUserStatus } from "../../service/FirmServices";
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import { PrimaryButton } from "@fluentui/react";
import { t } from "i18next";
import { AuthRoutes } from "../../constants/Constants";

const UserView = () => {
    const location = useLocation();
    const navigate = useNavigate();   
    const { state } = location;
    
    const [breadCrumbItems, setBreadCrumbItemList] = useState(state.breadCrumbItems);
    console.log(state);

    useEffect(()=>{
        if(!state.breadCrumbItems.some(x => x.key === "user")){
            state.breadCrumbItems.push({text: t("user.user"),key: "user" });
            setBreadCrumbItemList(()=>state.breadCrumbItems);
        }
        
    },[])

    return <>
    <CustomBreadCrumb items={state.breadCrumbItems} /></>
}

export default UserView;